import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6690f0e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h5-preview-container" }
const _hoisted_2 = { class: "h5-preview__frame-wrap" }
const _hoisted_3 = { class: "h5-preview__frame-contain" }
const _hoisted_4 = ["src"]


const __default__ = {
  name: 'H5Preview'
}

import { computed, toRef } from 'vue'
import { useGroupStore } from '@/store/group'
import { useH5PreviewPreference } from './hooks'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const groupStore = useGroupStore()
const IS_PROD = process.env.NODE_ENV === 'production'
const IS_KH5 = process.env.VUE_APP_MOBILE_RUN_IN_KH5 === 'true'

const h5Url = computed(() =>
  !IS_PROD && IS_KH5
    ? `https://kh5.wps.cn/m/${groupStore.groupId}`
    : `https://k.wps.cn/m/${groupStore.groupId}`
)

const h5PreviewPreference = useH5PreviewPreference({ init: true })
const previewIframeRef = toRef(h5PreviewPreference, 'iframeRef')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("iframe", {
          ref_key: "previewIframeRef",
          ref: previewIframeRef,
          src: _unref(h5Url),
          frameborder: "0"
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}
}

})